import React, { Fragment } from 'react';
import IntlMessages from 'util/IntlMessages';
import BasicDetailRow from 'components/basicDetailRow';

const ProductDetailTable = ({ displayData }) => {
    if (displayData) {
        return (
            <table className="default-table table table-sm table-responsive-sm table-hover">
                <tbody>
                    <BasicDetailRow label={<IntlMessages id="label.description" />} description={displayData?.description} />
                    <BasicDetailRow label={<IntlMessages id="label.manager" />} description={displayData?.manager} />
                    <BasicDetailRow label={<IntlMessages id="label.fyBudget" />} description={displayData?.fyBudget} />
                    <BasicDetailRow label={<IntlMessages id="label.valueStream" />} description={displayData?.valueStream} />
                    <BasicDetailRow label={<IntlMessages id="label.businessUnit" />} description={displayData?.businessUnit} />
                    <BasicDetailRow label={<IntlMessages id="label.productType" />} description={displayData?.productType} />
                </tbody>
            </table>
        );
    } else {
        return <Fragment></Fragment>;
    }
};

export default ProductDetailTable;


// WEBPACK FOOTER //
// ./components/Agile/product/productDetail/productDetailTable/index.js